import React from "react"

import { useBadge } from "../../../hooks/useBadge"

export const withBadge = Component => ({ name = "Badge", tags, layout }) => {
  const { message, colour } = useBadge(tags)

  Component.displayName = name
  return <Component colour={colour} message={message} layout={layout} />
}